import { OutlookCardView } from "./view-outlook-card";
import type { OutlookCardProps } from "./types-outlook-card";

export function OutlookCard(props: OutlookCardProps) {
  return <OutlookCardView {...props} />;
}

export type * from "./types-outlook-card";
